import { apiRequest } from "./apiClient";
import { stateChangingRequest } from "./authApi";

export function getStarters() {
  return apiRequest("/api/starters");
}

export function createStarter(starter) {
  return stateChangingRequest("/api/starters", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(starter),
  });
}

export function updateStarter(starterId, starter) {
  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(starter),
    },
  );
}

export function updateStarterVisibility(starterId, visibility) {
  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}/visibility`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visibility }),
    },
  );
}

export function uploadStarterImage(starterId, image, fileName = image.name) {
  const formData = new FormData();
  formData.append("image", image, fileName);

  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}/images`,
    {
      method: "POST",
      body: formData,
    },
  );
}

export function deleteStarterImage(starterId, imageId) {
  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}/images/${encodeURIComponent(
      imageId,
    )}`,
    { method: "DELETE" },
  );
}

export function reorderStarterImages(starterId, imageIds) {
  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}/images/order`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ imageIds }),
    },
  );
}

export function importStarters(starters) {
  return stateChangingRequest("/api/starters/import", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ starters }),
  });
}

export function deleteStarter(starterId) {
  return stateChangingRequest(
    `/api/starters/${encodeURIComponent(starterId)}`,
    {
      method: "DELETE",
    },
  );
}
